import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "@/landing/LanguageContext";
import { images } from "@/landing/data";
import { CTAButton, WhatsTag } from "@/landing/ui";

const EASE = [0.22, 1, 0.36, 1];

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 22 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.85, delay, ease: EASE },
});

const Hero = () => {
  const { t } = useLang();
  const h = t.hero;

  return (
    <section id="top" className="relative min-h-screen overflow-hidden bg-carbon text-cream">
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Activación Kundalini"
          className="h-full w-full object-cover object-center opacity-90 lg:opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/50 to-carbon/25 lg:bg-gradient-to-r lg:from-carbon lg:via-carbon/70 lg:to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-carbon/55 via-transparent to-carbon lg:from-carbon/70 lg:via-carbon/10 lg:to-carbon/50" />
      </div>

      <div className="relative mx-auto flex min-h-screen max-w-7xl flex-col justify-center px-6 pt-32 pb-24 lg:px-10">
        <motion.span
          {...fade(0)}
          className="mb-8 font-sans text-xs font-semibold tracking-[0.24em] uppercase text-sand"
        >
          {h.badge}
        </motion.span>

        <motion.h1
          {...fade(0.1)}
          className="max-w-4xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-balance [text-shadow:0_2px_24px_rgba(0,0,0,0.75)] sm:text-5xl lg:text-7xl"
        >
          {h.title}
        </motion.h1>

        <motion.p
          {...fade(0.22)}
          className="mt-9 max-w-2xl font-sans text-base font-light leading-relaxed text-cream/90 [text-shadow:0_1px_16px_rgba(0,0,0,0.7)] lg:text-xl"
        >
          {h.subtitle}
        </motion.p>

        <motion.div {...fade(0.34)} className="mt-11 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
          <CTAButton testid="hero-cta" source="hero-cta" variant="light">
            {h.cta}
          </CTAButton>
          <WhatsTag dark />
        </motion.div>

        <motion.ul {...fade(0.46)} className="mt-12 grid max-w-2xl grid-cols-1 gap-y-3 sm:grid-cols-2">
          {h.bullets.map((b) => (
            <li
              key={b}
              className="flex items-start gap-3 font-sans text-sm font-light leading-snug text-cream/90 [text-shadow:0_1px_10px_rgba(0,0,0,0.6)] lg:text-base"
            >
              <Check size={17} className="mt-0.5 shrink-0 text-sand" /> {b}
            </li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default Hero;
